import type { PlaceLevel } from "./types";
import { PLACE_LEVEL } from "./types";

/**
 * Country and StateRegion levels get a specific "Country" label instead of the
 * generic "This place"/"Exact" text that `getPlaceExactnessOptions` uses for
 * every level that collapses to a single stop (Continent, CountryRegion,
 * Country, StateRegion). Continent/CountryRegion intentionally stay generic —
 * this mirrors legacy, which only special-cases Country/StateRegion.
 */
export const getExactnessButtonLabelKey = (level: PlaceLevel | null): string => {
    switch (level) {
        case PLACE_LEVEL.Country:
        case PLACE_LEVEL.StateRegion:
            return "location.exactness.exactToCountry";
        default:
            return "location.exactness.exact";
    }
};

export const getExactnessSingleSelectLabelKey = (
    level: PlaceLevel | null,
    selectedOptionFullLabelKey: string | null,
): string => {
    switch (level) {
        case null:
        case PLACE_LEVEL.Continent:
        case PLACE_LEVEL.CountryRegion:
            return "location.exactness.exact";
        case PLACE_LEVEL.Country:
        case PLACE_LEVEL.StateRegion:
            return "location.exactness.exactToCountry";
        default:
            if (!selectedOptionFullLabelKey) return "location.exactness.exactTo";
            return selectedOptionFullLabelKey;
    }
};

/**
 * Short-form counterpart to `getExactnessButtonLabelKey`, for per-stop slider labels
 * rather than a standalone button. Country and StateRegion still get the specific
 * "Country" label instead of the generic "This place" text that
 * `getPlaceExactnessOptions` uses for every level that collapses to a single stop.
 */
export const getExactnessStopLabelKey = (level: PlaceLevel | null): string => {
    switch (level) {
        case PLACE_LEVEL.Country:
        case PLACE_LEVEL.StateRegion:
            return "location.exactness.country";
        default:
            return "location.exactness.thisPlace";
    }
};
